import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { checkIsManager } from '../api/departamentoManagers';

/**
 * Hook para verificar si el usuario actual es manager de algún departamento
 * También considera a los admins como managers
 */
export function useIsManager() {
  const { user, bootstrapped } = useAuth();
  const [isManager, setIsManager] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!bootstrapped) {
      return;
    }

    if (!user) {
      setIsManager(false);
      setLoading(false);
      return;
    }

    // Los admins siempre son considerados managers
    const isAdmin = user.roles?.includes('admin');
    if (isAdmin) {
      setIsManager(true);
      setLoading(false);
      return;
    }

    // Verificar si es manager de algún departamento
    const checkManager = async () => {
      try {
        const result = await checkIsManager();
        setIsManager(result.isManager);
      } catch (error) {
        setIsManager(false);
      } finally {
        setLoading(false);
      }
    };

    checkManager();
  }, [user, bootstrapped]);

  return { isManager: isManager ?? false, loading };
}

